import request from '../request.js'

//zwh
// 获取菜单信息（张卫华）
const getLimitRoleByLimitId = function (data) {
    return request({
        url: 'sysLimitRole/getLimitRoleByLimitId',
        method: 'post',
        data
    })
}
// 获取限制的菜单信息（张卫华）
const getLimitMenuByLimitIdMore = function (data) {
    return request({
        url: 'sysLimitRoleMenu/getLimitMenuByLimitIdMore',
        method: 'post',
        data
    })
}
// 获取限制的菜单按钮信息（张卫华）
const getLimitBtnByLimitIdMore = function (data) {
    return request({
        url: 'sysLimitRoleMenuBtn/getLimitBtnByLimitIdMore',
        method: 'post',
        data
    })
}
export {
    getLimitRoleByLimitId,
    getLimitMenuByLimitIdMore,
    getLimitBtnByLimitIdMore,
}